export enum CustomerInterested {
  VERY_INTERESTED = 'VERY_INTERESTED',
  INTERESTED = 'INTERESTED',
  LOW_INTERESTED = 'LOW_INTERESTED',
  NOT_INTERESTED = 'NOT_INTERESTED',
}
